import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Home from '../pages/home'
import Products from '../pages/products'
import NotFound from '../pages/notFound'
import SignUp from '../pages/signup'
// import Contact from '../pages/contact'
import Inficonnect from '../pages/inficonnect'
import EmailVerification from '../pages/emailVerification'
import Enterprise from '../pages/enterprise'
import Customers from '../pages/customers'
import RequestDemo from '../pages/requestDemo.js'
import Expressbazaar from '../pages/expressbazaar.js'
// import Qwikco from '../pages/qwikco.js'
import Ourstory from '../pages/ourstory.js'
import ScrollToTop from '../components/scrollToTop.js'
import ConnectPlus from '../pages/connectPlus/index.js'
import VictorPage from '../pages/victor/index.js'
import ShopSenseAILanding from '../pages/shopsense/index.js'
import GeniusLanding from '../pages/genius/index.js'
import Qwikco from '../pages/qwikco/index.js'
import XpressBazaar from '../pages/xpressBazaar/index.js'
import ZeroClick from '../pages/0click/index.js'
import Chatboat from '../pages/chatboat/index.js'
import Contact from '../pages/contact.js'
import PrivacyPolicy from '../pages/privacy-policy.js'

const RoutesPage = () => {
  return (
    <BrowserRouter>
    <ScrollToTop />
        <Routes>
            <Route path='/' element={<Home/>}/>
            <Route path='/products' element={<Products/>}/>
            <Route path='/products/sales/inficonnect' element={<Inficonnect/>}/>
            <Route path='/products/sales/zeroclik' element={<ZeroClick/>}/>
            <Route path='/products/sales/0clik' element={<ZeroClick/>}/>
            <Route path='/products/sales/chatbot' element={<Chatboat />}/>
            <Route path='/products/sales/xpressbazaar' element={<XpressBazaar/>}/>
            <Route path='/products/sales/qwikco' element={<Qwikco/>}/>
            <Route path='/products/sales/inficonnect/signup' element={<SignUp/>}/>
            <Route path='/products/sales/connect-plus' element={<ConnectPlus/>}/>
            <Route path='/products/sales/shop-sense' element={<ShopSenseAILanding/>}/>
            <Route path='/products/sales/genius' element={<GeniusLanding/>}/>
            <Route path='/products/sales/victor' element={<VictorPage/>}/>
            <Route path='/request-demo' element={<RequestDemo/>}/>
            <Route path='/enterprise' element={<Enterprise/>}/>
            <Route path='/customers' element={<Customers/>}/>
            <Route path='/contact' element={<Contact />} />
            <Route path='/thankyou' element={<EmailVerification/>}/>
            <Route path='/ourstory' element={<Ourstory/>}/>
            <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
            <Route path='*' element={<NotFound/>}/>
        </Routes>
    </BrowserRouter>
  )
}

export default RoutesPage
